export default __webpack_public_path__ + "static/media/18.0c2cd9e2.jpeg";